export const NAME = 'profile-configuration';
